import { setMultiUser } from "../../actions/user";
import More from "../../controls/More";
import { relaunch } from "../../util/commandLine";
import { ComponentEx, connect, translate } from "../../controls/ComponentEx";
import getText from "./texts";
import * as React from "react";
import { Alert, Button, FormControl, FormGroup, HelpBlock, } from "react-bootstrap";
class SettingsVortex extends ComponentEx {
    constructor(props) {
        super(props);
        this.initState({
            oldMultiUser: props.multiUser,
        });
    }
    render() {
        const { t, multiUser } = this.props;
        const { oldMultiUser } = this.state;
        const restartNoti = multiUser === oldMultiUser ? null : (React.createElement(HelpBlock, null,
            React.createElement(Alert, null,
                t("You need to restart Vortex to activate this change"),
                React.createElement(Button, { onClick: this.restart, style: { marginLeft: "1em" } }, t("Restart now")))));
        return (React.createElement("form", null,
            React.createElement(FormGroup, { controlId: "muMode" },
                React.createElement(FormControl.Static, { componentClass: "div" },
                    t("Multi-User Mode"),
                    React.createElement(More, { id: "more-multi-user", name: t("Multi-User Mode") }, getText("multi-user", t))),
                React.createElement(FormControl, { componentClass: "select", onChange: this.selectMode, value: multiUser ? "on" : "off" },
                    React.createElement("option", { value: "on" }, t("Shared")),
                    React.createElement("option", { value: "off" }, t("Per-User"))),
                restartNoti)));
    }
    selectMode = (evt) => {
        const { onSetMultiUser } = this.props;
        onSetMultiUser(evt.currentTarget.value === "on");
    };
    restart = () => {
        relaunch();
    };
}
function mapStateToProps(state) {
    return {
        multiUser: state.user.multiUser,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetMultiUser: (multiUser) => dispatch(setMultiUser(multiUser)),
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(SettingsVortex));
